import * as React from "react";
import styled from "styled-components";

interface Props {
  type: string;
  children?: React.ReactNode;
}

export function AttachmentEditor({ type, children }: Props) {
  return (
    <Container>
      <Type>{type}</Type>
      {children}
    </Container>
  );
}

const Container = styled.div`
  background: var(--box-color);
  padding: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.125);
  border: 1px solid var(--box-border-color); !important;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Type = styled.div``;
